import React, { useState, useEffect } from "react";
import { YMButton, YMCard, YMInput, YMMultiSelect } from "../../../ym-components";
import { HiSearch } from "react-icons/hi";
import { WorkspaceTagType } from "../../workspace/Api";

// LocalStorage helpers for tag filter persistence
export const getProjectTagFilterFromLocalStorage = (workspaceId: string): string[] => {
  const tagFilter = localStorage.getItem("projectTagFilter-" + workspaceId);
  if (tagFilter) {
    return JSON.parse(tagFilter) as string[];
  }
  return [];
};

const setProjectTagFilterToLocalStorage = (workspaceId: string, tagIds: string[]) => {
  localStorage.setItem("projectTagFilter-" + workspaceId, JSON.stringify(tagIds));
};

export default function ProjectFilter({
  onSearch,
  onTagsChange,
  workspaceId,
  availableTags,
}: {
  onSearch: (name: string) => void;
  onTagsChange: (tagIds: string[]) => void;
  workspaceId: string;
  availableTags: WorkspaceTagType[];
}) {
  const [name, setName] = useState("");
  const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);

  // Load saved tag filter on mount
  useEffect(() => {
    const savedTags = getProjectTagFilterFromLocalStorage(workspaceId);
    setSelectedTagIds(savedTags);
    onTagsChange(savedTags);
  }, [workspaceId]);

  const handleSearch = () => {
    onSearch(name);
  };

  const handleTagsChange = (tagNames: string[]) => {
    // Convert tag names to tag IDs
    const tagIds = tagNames
      .map((name) => {
        const tag = availableTags.find((t) => t.name === name);
        return tag?.id || tag?.name;
      })
      .filter((id): id is string => id !== undefined);

    setSelectedTagIds(tagIds);
    setProjectTagFilterToLocalStorage(workspaceId, tagIds);
    onTagsChange(tagIds);
  };

  // Get tag names from IDs for the multiselect component
  const selectedTagNames = selectedTagIds
    .map((id) => {
      const tag = availableTags.find((t) => t.id === id || t.name === id);
      return tag?.name;
    })
    .filter((name): name is string => name !== undefined);

  return (
    <YMCard>
      <div className="flex flex-col">
        <div className="format">
          <h4 className="text-indigo-800">Filtrer les projets</h4>
          <p className="text-sm text-indigo-900">
            Recherchez un projet par son nom ou filtrez par tags
          </p>
        </div>
        <div className="flex gap-4 mt-4 items-end w-1/2">
            <div className={"w-1/2"}>
              <YMInput
                label={"Nom du projet"}
                value={name || ""}
                onChange={setName}
              />
            </div>
            <div className={"w-1/2"}>
                                <div className="flex items-center">
                                    <div className="mt-5 font-bold text-indigo-900 text-xs">
                                        Tags
                                    </div>
                                </div>
                                <YMMultiSelect
            wordList={availableTags.map((tag) => tag.name)}
            values={selectedTagNames}
            onListChange={handleTagsChange}
          />
          </div>
          <div>
            <YMButton
              text="Rechercher"
              onClick={handleSearch}
              icon={<HiSearch className="h-4 w-4 mr-2" />}
            />
          </div>
        </div>
      </div>
    </YMCard>
  );
}
